<template>
  <div>
    <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
    <Dialog header="Employee Position" :visible.sync="displayBasic"
            :style="{width: '60vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
          <div class="p-field p-col-12 p-md-4">
            <label for="reportingMethod">Reporting Method </label>
            <Dropdown id="reportingMethod" optionLabel="name" v-model="reportingMethod" :options="reportingMethodList"
                      placeholder="--Select--"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
          <div class="p-field p-col-12 p-md-12">
            <DataTable :value="employeeList" dataKey="id" :paginator="true" :rows="8"
                       :selection.sync="selectedEmployee"
                       :filters="filters" selectionMode="multiple">
              <Column header="Employee Id" field="employeeId">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['value']"/>
                </template>
              </Column>
              <template #empty>
                No customers found.
              </template>
              <Column header="Name" field="employeeName">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['value']"/>
                </template>
              </Column>
              <Column header="Employee Address"/>
              <Column header="Group"/>
              <Column header="Branch Office"/>
              <Column header="Department"/>
            </DataTable>
          </div>
        </div>

      </form>
      <template #footer>
        <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
          <div class="p-field p-col-12 p-md-6">
            <Button class="p-button-raised" label="Save" icon="pi pi-save"
                    />
            <Button class="p-button-raised p-button-danger" label="Cancel"
                    @click.prevent="cancel"/>
          </div>
        </div>
      </template>
    </Dialog>
    <DataTable :value="employeeList" dataKey="id" :paginator="true" :rows="8"
               :filters="filters" selectionMode="multiple">
      <template #header>
        <span>Assigned Supervisors</span>
      </template>
      <template #empty>
        No records found.
      </template>
      <Column header="Name" field="employeeName">
      </Column>
      <Column header="Reporting Method"/>
      <Column header="Actions"/>
    </DataTable>
    <hr class="p-mt-5 p-mb-5"/>
    <DataTable :value="employeeList" dataKey="id" :paginator="true" :rows="8"
               :filters="filters" selectionMode="multiple">
      <template #header>
        <span>Assigned Subordinates</span>
      </template>
      <template #empty>
        No records found.
      </template>
      <Column header="Name" field="employeeName">
      </Column>
      <Column header="Reporting Method"/>
      <Column header="Actions"/>
    </DataTable>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'

export default {
  name: 'reportTo',
  data() {
    return {
      loading: false,
      editing: false,
      holidayId: null,
      displayBasic: false,
      filters: {},
      selectedEmployee: null,
      reportingMethod: {},
      reportingMethodList: [{name: 'Supervisor'}, {name: 'Subordinate'}]
    }
  },
  computed: {
    employeeList() {
      return this.$store.state.hr.employeeList
    }
  },
  mounted() {
    this.findEmployeeList()
  },
  methods: {
    async findEmployeeList() {
      await this.$store.dispatch('loadHrMasterSetupList')
    },
    reset() {
      this.reportingMethod = {}
      this.displayBasic = false
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Button,
    InputText,
    Dropdown,
    DataTable,
    Column,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// report-to.vue?14b24fa2